import * as React from 'react';
import CloseIcon from '@mui/icons-material/Close';


export default function Ward2Modal(props) { 
    if (!props.open) {
        return null;
    }


        return(
            <React.Fragment>
                <div className="Modal">
                    <div className="ModalBg">
                        <div className="ModalContent ward2">
                            <header>
                            <h1>Welcome to Children's Ward 2!</h1>
                            </header>
                            <section>
                            <img src={require('../../assets/images/ward2.PNG')} />
                                    Eu proident duis aute commodo esse esse nulla cillum et laboris dolore ullamco do. Proident officia eu sit sit amet exercitation officia reprehenderit deserunt excepteur ipsum anim incididunt. Reprehenderit minim Lorem elit magna tempor ad aliquip tempor cillum culpa laborum ut adipisicing ea. Aliqua consectetur duis velit minim ullamco veniam minim consectetur excepteur exercitation sunt. Laborum 
                                
                          
                            </section>  
                            <footer>
                                <a href="#" onClick={() => props.onClose()}><CloseIcon style={{ fontSize: 40, color: "black" }} /></a>
                            </footer>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    
    
}